<section>
  <remote-update-domain-multi-step-form
    [store]="store"
    (formCancel)="onCancel()"
    (nextStep)="goToNextStep()"
    [menuItems]="firmwareMenuItems()"
    [actionButtonLabel]="actionButtonLabel"
    [finalButtonText]="'Create draft'">
    @if (isLoading() || updatePackageModelIsLoading()) {
    <mat-progress-bar mode="indeterminate" value="50" color="primary"></mat-progress-bar>
    }
    <remote-update-domain-compatibility [currentSection]="currentSection" />
    <remote-update-domain-file-upload [currentSection]="currentSection" />
    <remote-update-domain-manifest-information [currentSection]="currentSection" />
    <remote-update-domain-app-distribution [currentSection]="currentSection" />
    <remote-update-domain-package-metadata [currentSection]="currentSection" />
    <remote-update-domain-release-notes [currentSection]="currentSection" />
    <remote-update-domain-summary [currentSection]="currentSection" />
  </remote-update-domain-multi-step-form>
</section>
